import AdminSignUpPage from "./AdminSignUpPage";

export default AdminSignUpPage;
